import { encode, decode } from "gpt-tokenizer";

export const encodeText = (text: string) => {
  return encode(text);
};

export const decodeTokens = (tokens: number[]) => {
  return decode(tokens);
};
